import { t, type Locale } from "./i18n";

type Props = {
  locale: Locale;
};

export function LegalFooter({ locale }: Props) {
  return (
    <nav className="footer-legal" aria-label={t(locale, "legalNavLabel")}>
      <a
        href={`https://werkstate.app/privacy.html?lang=${locale}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t(locale, "legalPrivacy")}
      </a>
      <a
        href={`https://werkstate.app/terms.html?lang=${locale}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t(locale, "legalTerms")}
      </a>
      <a
        href={`https://werkstate.app/imprint.html?lang=${locale}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t(locale, "legalImprint")}
      </a>
    </nav>
  );
}
